import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import relativeTime from "dayjs/plugin/relativeTime";
import localeData from "dayjs/plugin/localeData";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/sv";

dayjs.extend(relativeTime);
dayjs.extend(localeData);

export const dateFromNow = (date, locale) => dayjs(date).locale(locale).fromNow();

export default class DateFromNow extends Helper {
  @service intl;

  compute([date]) {
    return dateFromNow(date, this.intl.primaryLocale);
  }
}
